<p-password [toggleMask]="true" appendTo="body" #pass="ngModel" autocomplete="off"
    [ngClass]="{'ng-invalid ng-dirty' : showErrors && (submitAttempt || pass.touched || pass.dirty) && (!password || password.length == 0) ||
    showErrors && !(!password || password.length == 0) && !isValid}"
    mediumLabel="{{'mot_de_passe_oublier.new_password.labels.medium_password' | translate}}"
    placeholder="{{'mot_de_passe_oublier.new_password.labels.new_password'|translate}}" promptLabel="&nbsp;"
    strongLabel="{{'mot_de_passe_oublier.new_password.labels.strong_password' | translate}}"
    [strongRegex]="regex" [(ngModel)]="password" (ngModelChange)="checkValidity()"
    weakLabel="{{'mot_de_passe_oublier.new_password.labels.weak_password' | translate}}"
    (onFocus)="showErrors = false;" (onBlur)="showErrors = true">
    <ng-template pTemplate="header" style="text-align: left !important">
        <h6>{{"mot_de_passe_oublier.new_password.labels.suggestions" | translate }}</h6>
    </ng-template>
    <ng-template pTemplate="footer" style="text-align: left !important">
      <div class="footer-content">
        <p-divider></p-divider>
        <p class="mt-1 mb-1">{{"mot_de_passe_oublier.new_password.labels.pick_password" | translate }}</p>
        <div class="mt-1 mb-1 ml-2" style="line-height: 1.5">
          <div>
            <i *ngIf="hasMinLength()" class="pi pi-check" style="color: green"></i>
            <i *ngIf="!hasMinLength()" class="pi pi-times" style="color: red"></i>
            {{"mot_de_passe_oublier.errors.pass_min_char" |
            translate: {x: minPassword} }}
          </div>
          <div>
            <i *ngIf="hasMaxLength()" class="pi pi-check" style="color: green"></i>
            <i *ngIf="!hasMaxLength()" class="pi pi-times" style="color: red"></i>
            {{"mot_de_passe_oublier.errors.pass_max_char" |
            translate: {x: maxPassword} }}
          </div>
        </div>
        <p class="mb-0 pl-2">
          {{"mot_de_passe_oublier.new_password.labels.nbr_category" | translate }}
        </p>
        <div class="mt-0 ml-2">
          <div>
            <i *ngIf="hasLower()" class="pi pi-check" style="color: green"></i>
            <i *ngIf="!hasLower()" class="pi pi-times" style="color: red"></i>
            {{"mot_de_passe_oublier.errors.pass_lowercase" |
            translate }}
          </div>
          <div>
            <i *ngIf="hasUpper()" class="pi pi-check" style="color: green"></i>
            <i *ngIf="!hasUpper()" class="pi pi-times" style="color: red"></i>
            {{"mot_de_passe_oublier.errors.pass_uppercase" |
            translate }}
          </div>
          <div>
            <i *ngIf="hasSpecial()" class="pi pi-check" style="color: green"></i>
            <i *ngIf="!hasSpecial()" class="pi pi-times" style="color: red"></i>
            {{"mot_de_passe_oublier.errors.pass_min_special_char" |
            translate }}
          </div>
          <div>
            <i *ngIf="hasNumber()" class="pi pi-check" style="color: green"></i>
            <i *ngIf="!hasNumber()" class="pi pi-times" style="color: red"></i>
            {{"mot_de_passe_oublier.errors.pass_numeric" |
            translate }}
          </div>
        </div>
        <p-divider></p-divider>
        <p class="mt-1 mb-1">{{'mot_de_passe_oublier.new_password.labels.dont_contain' | translate}}</p>
        <div class="mt-0 ml-2">
          <div>- {{'mot_de_passe_oublier.errors.dont_contain_username' | translate}}</div>
          <div>- {{'mot_de_passe_oublier.errors.dont_contain_nom_prenom' | translate}}</div>
          <div>- {{'mot_de_passe_oublier.errors.dont_contain_birthyear' | translate}}</div>
          <div>- {{'mot_de_passe_oublier.errors.dont_contain_suite_num' | translate}}</div>
          <div>- {{'mot_de_passe_oublier.errors.dont_contain_suite_alpha' | translate}}</div>
          <div>- {{'mot_de_passe_oublier.errors.dont_contain_azerty_querty' | translate}}</div>
        </div>
      </div>
    </ng-template>
</p-password>
<small *ngIf="showErrors && (submitAttempt || pass.touched || pass.dirty) && (!password || password.length == 0)" class="p-error">
    {{"mot_de_passe_oublier.errors.champ_obligatoire" | translate}}
</small>
<small *ngIf="showErrors && !(!password || password.length == 0) && !isValid" class="p-error">
    {{"mot_de_passe_oublier.errors.pass_non_valide_ligne_1" | translate}}
    <br>
    {{"mot_de_passe_oublier.errors.pass_non_valide_ligne_2" | translate}}
</small>
